// Sends an analytics event when PostHog is loaded; does nothing in builds without a key
export const track = (event, properties) => {
  if (typeof window !== "undefined" && window.posthog) window.posthog.capture(event, properties)
}

const MAX_QUERY_LENGTH = 100
// Queries that look like a key or an email address are never sent, so search data is safe to share
const SENSITIVE_QUERY = /(sk|pk|rk|phc)_[a-z0-9_]{6,}|@/i

export const trackSearch = (query, resultCount, searchArea) => {
  const trimmed = query.trim()
  if (!trimmed || SENSITIVE_QUERY.test(trimmed)) return

  track("search_performed", {
    query: trimmed.slice(0, MAX_QUERY_LENGTH),
    result_count: resultCount,
    search_area: searchArea,
  })
}

const elementFromNode = (node) => (node && node.nodeType === Node.TEXT_NODE ? node.parentElement : node)

// Fires for both the Copy buttons and keyboard copies, so every way of copying code is counted once
const onCopy = () => {
  const selection = window.getSelection()
  const element = elementFromNode(selection && selection.anchorNode)
  if (!element || !element.closest("pre")) return

  const snippet = element.closest("[data-snippet]")
  track("code_copied", {
    language: snippet ? snippet.dataset.language : undefined,
    snippet: snippet ? snippet.dataset.snippet : undefined,
  })
}

const onSearchResultClick = (link) => {
  const results = link.closest(".search__result")
  const search = link.closest(".search")
  const input = search && search.querySelector(".search__field__input")
  const query = input ? input.value.trim() : ""
  if (SENSITIVE_QUERY.test(query)) return

  track("search_result_clicked", {
    query: query.slice(0, MAX_QUERY_LENGTH),
    position: Array.from(results.querySelectorAll("a")).indexOf(link) + 1,
    result_url: link.pathname + link.hash,
  })
}

const onClick = (event) => {
  const link = event.target.closest && event.target.closest("a[href]")
  if (!link) return

  if (link.closest(".search__result") && link.hostname === window.location.hostname) {
    onSearchResultClick(link)
    return
  }

  if (/^https?:$/.test(link.protocol) && link.hostname !== window.location.hostname) {
    track("outbound_link_clicked", {
      destination: link.hostname + link.pathname,
      link_text: link.textContent.trim().slice(0, MAX_QUERY_LENGTH),
    })
  }
}

export const listenForDocsEvents = () => {
  document.addEventListener("copy", onCopy)
  // Capture phase, so the click is recorded before the link navigates
  document.addEventListener("click", onClick, true)
}
